import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@shared/components/ui/button';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface RateItemDataFallbackProps {
  data: unknown;
}

export const RateItemDataFallback = ({ data }: RateItemDataFallbackProps) => {
  const { t } = useTranslation('ratesModule');
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <span className="text-sm text-warning">
          {t('itemData.invalidData')}
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          className="h-6 px-2"
        >
          <FontAwesomeIcon
            icon={isExpanded ? faChevronUp : faChevronDown}
            className="w-3 h-3 mr-1"
          />
          {isExpanded ? t('itemData.collapse') : t('itemData.expand')}
        </Button>
      </div>

      {isExpanded && (
        <pre className="bg-gray-50 dark:bg-gray-900 p-3 rounded-lg overflow-auto max-h-48 text-xs">
          <code>{JSON.stringify(data, null, 2)}</code>
        </pre>
      )}
    </div>
  );
};
